// library imports
import { useDispatch } from "react-redux";

// User Component imports
import { ApiRequest } from "_core/apis/ApiRequest";
import { setApiTimestamp } from "_core/slices/datas/TransactionSlice";


// HRニュース エンドページ設定（機能ショートカットボタン）保存
const AdminHrNewsEndpageSaveApi = () => {
    const dispatch = useDispatch();
    const url = "/admin/hr_news_endpage_save";

    // params: { buttons: [{ label, message }, ...] }
    const ExecAdminHrNewsEndpageSaveApi = async (params) => {
        const requestParams = {
            // バックエンドは {"buttons":[{label,message}]} のJSON文字列で受け取る
            endpage_data: JSON.stringify({ buttons: params.buttons || [] }),
        };

        let response = null;
        let error = null;
        try {
            response = await ApiRequest({ url, requestParams });
        } catch (e) {
            error = e;
        }

        if (response !== null && response.error_code === 0) {
            dispatch(setApiTimestamp(response['now_time']));
        }
        return { response, error };
    };

    return ExecAdminHrNewsEndpageSaveApi;
};

export default AdminHrNewsEndpageSaveApi;
